<aside>
  <section class="valid8-container">
    <img src="assets/images/logo_valid8.svg" alt="valid8" />
    <h1>
      Valide seus documentos de
      <br />
      maneira eficiente e segura
      <br />
      com a IA do <strong>:valid8</strong>.
    </h1>
  </section>
  <section class="features-container">
    <div>
      <ul>
        <li>
          <img src="assets/icons/gavel.svg" alt="Agilidade jurídica e análise de documentos" />
          Agilidade jurídica e
          <br />
          análise de documentos
        </li>
        <li>
          <img src="assets/icons/shield_lock.svg" alt="Redução de riscos" />
          Redução de riscos
        </li>
        <li>
          <img src="assets/icons/language.svg" alt="Multi-idiomas" />
          Multi-idiomas
        </li>
        <li>
          <img src="assets/icons/forum.svg" alt="Chatbot integrado" />
          Chatbot integrado
        </li>
        <li>
          <img src="assets/icons/instant_mix.svg" alt="Personalização de validações" />
          Personalização de validações
        </li>
      </ul>
      <img
        src="assets/images/logo_designed_upd8.svg"
        alt="designed by upd8"
        class="logo-designed-upd8"
      />
    </div>
  </section>
</aside>
<main>
  <router-outlet />
</main>
